import { createFormHookContexts } from '@tanstack/react-form';

/**
 * Shared TanStack Form contexts for field components exported by this package.
 *
 * Applications adopting shared field components must pass these contexts to
 * `createFormHook`.
 */
export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();
